import { c as _c } from "react/compiler-runtime";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
export const SchemaLocalBusiness = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <script dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org/",
        "@type": "LocalBusiness",
        name: replaceSnappTripBasedOnChannel("\u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E"),
        image: `${getOrigin()}/logo.png`,
        ...(isChannel(["snapp-ir"]) ? {
          address: {
            "@type": "PostalAddress",
            streetAddress: "\u0632\u0639\u0641\u0631\u0627\u0646\u06CC\u0647",
            addressLocality: "Tehran",
            addressRegion: "Tehran Province",
            addressCountry: "IR"
          }
        } : {
          address: "Tehran Province, Tehran, Mehrdad, QCCC+977, Iran"
        }),
        geo: {
          "@type": "GeoCoordinates",
          latitude: isChannel(["snapp-ir"]) ? 35.8049 : 35.7709181,
          longitude: isChannel(["snapp-ir"]) ? 51.4166 : 51.4180978
        },
        openingHoursSpecification: [{
          "@type": "OpeningHoursSpecification",
          opens: "09:00",
          closes: "18:00",
          dayOfWeek: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]
        }],
        telephone: "02196669066",
        priceRange: "IRR"
      })
    }} suppressHydrationWarning={true} type="application/ld+json" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};